export const ERR_INVALID_BIC = 657;
export const ERR_NOT_ALLOWED_PAYMENT_TO_COUNTRY = 658;
export const ERR_NOT_ALLOWED_SWIFT = 659;
export const ERR_PREPAID_CARD_NOT_SUPPORTED = 3002;
export const ERR_REJECT_ALL_OCT_DETECTED = 1000;
export const ERR_REJECT_ALL_AFT_DETECTED = 1001;
export const ERR_COUNTRY_NOT_SUPPORTED = 3003;
export const ERR_PAYMENT_METHOD_TO_COUNTRY_NOT_SUPPORTED = 3004;
export const ERR_TYPE_OF_CARD_NOT_SUPPORTED = 3005;
export const ERR_DUPLICATED_REGISTRATION = 59;
export const ERR_WRONG_CODE = 43;
